import React from 'react'
import CustomPath from './CustomPath'

const OUTLINE_PATH =
    'M34.0918 20.0381H55.1621L38.1162 32.4229L44.627 52.4619L27.5811 40.0771L10.5352 52.4619L17.0459 32.4229L0 20.0381H21.0703L27.5811 0L34.0918 20.0381Z'
const RAW_WIDTH = 55.16
const RAW_HEIGHT = 52.46

/**
 * Star shape component
 * @type {import('./CustomPath').CustomPath}
 */
export const StarShape = React.forwardRef((props, ref) => {
    return <CustomPath {...props} ref={ref} data={OUTLINE_PATH} rawWidth={RAW_WIDTH} rawHeight={RAW_HEIGHT} />
})

export default StarShape
